import "./style.scss";

import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import AddToPhotosOutlinedIcon from "@mui/icons-material/AddToPhotosOutlined";
import { forwardRef, useCallback, useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/store";

import TitleCover from "../TitleCover";

interface IUploadImg {
    value: string | object;
    watchAvatar: string;
    onChange: (data: FileList | null) => void;
    mode: "new" | "edit" | "edit-page";
    editModeActive: boolean | undefined;
}

/**
 * Alternative version of Upload component
 * @param portrait If the image uploaded is a 3:4 photo format, this props = true.
 */
const UploadImg = forwardRef<any, IUploadImg>((props: IUploadImg, ref) => {
    const [t] = useTranslation();
    const { value, watchAvatar, onChange, mode, editModeActive } = props;
    const titleName = useAppSelector((state) => state.titles.title?.name as string);
    const inputRef = useRef<HTMLInputElement | null>(null);
    const firstRender = useRef(true);

    const imageSrc = useMemo(() => {
        if (typeof value === "object" && value !== null) {
            return URL.createObjectURL(value[0]);
        }
        return value;
    }, [value]);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        } else if (watchAvatar === "" && inputRef.current) {
            inputRef.current.value = "";
            // inputRef.current.click();
        }
    }, [watchAvatar]);

    const renderAvatar = useCallback(() => {
        if (imageSrc) {
            return <img className="new-title-cover" src={imageSrc} alt="Title cover image" />;
        } else
            return (
                <>
                    {editModeActive && (
                        <>
                            <label htmlFor="raised-button-file" ref={ref}>
                                <TitleCover
                                    title={titleName}
                                    style={{
                                        width: "120px",
                                        fontSize: "2rem",
                                        cursor: "pointer",
                                    }}
                                />
                            </label>
                            <div className="new-title-add-image">
                                <div
                                    className="add-image-button"
                                    itemType="label"
                                    onClick={() => inputRef.current?.click()}
                                >
                                    <AddToPhotosOutlinedIcon sx={{ width: 17, height: 17, color: "#275ab0" }} />
                                    <span>{t("NewTitle.AddImage")}</span>
                                </div>
                                <span className="add-image-subtitle">{t("NewTitle.PNGorJPEG")}</span>
                            </div>
                        </>
                    )}

                    {/** Dashed no picture img while create a title */}
                    {mode === "new" && (
                        <>
                            <label className="new-title-no-image" htmlFor="raised-button-file" ref={ref}>
                                <AddPhotoAlternateIcon sx={{ height: 40, width: 40 }} />
                            </label>
                            <div className="new-title-add-image">
                                <div
                                    className="add-image-button"
                                    itemType="label"
                                    onClick={() => inputRef.current?.click()}
                                >
                                    <AddToPhotosOutlinedIcon sx={{ width: 17, height: 17, color: "#275ab0" }} />
                                    <span>{t("NewTitle.AddImage")}</span>
                                </div>
                                <span className="add-image-subtitle">{t("NewTitle.PNGorJPEG")}</span>
                            </div>
                        </>
                    )}
                </>
            );
    }, [imageSrc, t, titleName, editModeActive]);

    return (
        <>
            <input
                ref={inputRef}
                onChange={(event) => onChange(event.target.files)}
                accept="image/*"
                style={{ display: "none" }}
                id="raised-button-file"
                type="file"
            />
            {renderAvatar()}
        </>
    );
});

UploadImg.displayName = "UploadImg";
export default UploadImg;
